import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LanguageDirection } from "../../utility/LanguageDirection";
import "./UploadReciept.css";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import 'react-toastify/dist/ReactToastify.css';


const UploadReciept = () => {
  const navigate = useNavigate();
  const { t} = useTranslation();
  const direction = LanguageDirection();
  // get current language from i18n

  return (
    <section className={`upload-reciept-component ${direction === 'rtl' ? 'rtl' : ''}`}>
    <div className="up-reciept-header" style={{ direction: direction === 'ltr' ? "rtl" : "ltr" }}>
      <h2 style={{ fontWeight: "800", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {t("uploadReceipt.title")}
      </h2>
      <button
        style={{ display: "flex", alignItems: "center", justifyContent: "center", direction: direction === "rtl" ? "rtl" : "ltr" }}
        onClick={() => navigate(-1)}
        className="go-back"
      >
        {direction === "ltr" ? <ArrowBackIosNewIcon sx={{ color: "#25485e" }} /> : <ArrowForwardIosIcon sx={{ color: "#25485e" }} />}
      </button>
    </div>

  </section>
  );
};

export default UploadReciept;
